import { styled } from '@clickcease/cc-client-components-lib'

export const SelectPixelsTocErrorStyled = styled('div', {
  display: 'flex',
})
export const SelectPixelsTocErrorText = styled('div', { color: '$error' })
export const SelectPixelsTocErrorUrl = styled('a', { marginLeft: '' + '$3' })
